
  <ebw-monorepo-sidebar-header [icon]="'rebase_edit'" [title]="'map.sidebar.valve.my_valve'" [isSvg]="false">
  </ebw-monorepo-sidebar-header>

  <div class="info-box info-valve">
    <mat-icon class="info-box__icon">info_outline</mat-icon>
    <div class="info-box__text">{{'map.sidebar.valve.info_section' | translate}}</div>
  </div>
